<script>
import { BDropdown, BDropdownItem, VBTooltip } from "bootstrap-vue";

export default {
  components: {
    BDropdown,
    BDropdownItem,
  },

  directives: {
    "b-tooltip": VBTooltip,
  },

  props: {
    segment: {
      type: Object,
      required: false,
      default: null,
    },

    segments: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped>
.tooltip-dropdown-item {
  z-index: 1100 !important;
  font-size: 14px;
}
</style>

<template>
  <BDropdown
    no-caret
    variant="link"
    class="nav-action nav-profile"
    toggle-class="text-decoration-none p-0"
    menu-class="bdk-lead-dropdown__dropdown"
  >
    <template #button-content>
      <div class="segments-button btn btn-bulldesk btn-bulldesk-transparent">
        <IconPencilFilled color="#71767D" :size="14"></IconPencilFilled>
        <span class="ml-2">{{ __("Selecionar segmentação") }}</span>
        <IconChevron class="toggle ml-auto"></IconChevron>
      </div>
    </template>

    <div class="dropdown-wrapper">
      <BDropdownItem href="/lead/segment/all">
        <a
          v-b-tooltip.top="{
            customClass: 'tooltip-dropdown-item',
          }"
          :title="'Ver todas'"
        >
          {{ __("Ver todas") }}
        </a>
      </BDropdownItem>

      <BDropdownItem
        :key="`${id}-${name}`"
        :href="`/lead/segment/${id}`"
        v-for="{ id, name } in segments"
        :class="{ 'is-selected': segment && segment.id === id }"
      >
        <a
          v-b-tooltip.top="{
            customClass: 'tooltip-dropdown-item',
          }"
          :title="name"
        >
          {{ name }}
        </a>
      </BDropdownItem>
    </div>
  </BDropdown>
</template>
